import React from "react";
import styled from "styled-components";

export const PageHeader = ({ title, subtitle, backdropText }) => {
  return (
    <Container>
      <CursiveTitleContainer>
        <CursiveTitle>{backdropText ?? title}</CursiveTitle>
      </CursiveTitleContainer>

      <MainTitle>{title}</MainTitle>

      {subtitle && (
        <>
          <Divider />
          <SubTitle>{subtitle}</SubTitle>
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-top: 8rem;
  margin-bottom: 4rem;
  width: 100%;

  @media screen and (max-width: 600px) {
    margin-top: 9rem;
    margin-bottom: 1rem;
  }
`;

const CursiveTitleContainer = styled.div`
  position: relative;
`;

const CursiveTitle = styled.h1`
  font-family: "Scriptina";
  font-weight: 200;
  font-size: 184px;
  letter-spacing: 10px;
  opacity: 0.2;
  position: absolute;
  margin: 0;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(-50%);

  @media screen and (max-width: 900px) {
    font-size: 64px;
    letter-spacing: 6px;
  }

  @media screen and (max-width: 600px) {
    font-size: 94px;
    letter-spacing: 4px;
    transform: translateY(-40%);
  }
`;

const MainTitle = styled.p`
  text-transform: uppercase;
  color: var(--color-bone);
  font-size: 48px;
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.5em;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 600px) {
    font-size: 34px;
    letter-spacing: 0.3em;
  }
`;

const Divider = styled.div`
  height: 1px;
  background-color: var(--color-emphasis);
  opacity: 1;
  width: 60px;
  margin: 1rem auto;
`;

const SubTitle = styled.p`
  text-transform: uppercase;
  color: var(--color-emphasis);
  font-size: 18px;
  font-weight: 600;
  margin: 0.6rem 0 0;
  letter-spacing: 0.4em;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 600px) {
    font-size: 15px;
    letter-spacing: 0.3em;
  }
`;
